import { io } from 'socket.io-client';

console.log('coming to socket for connection');
const socket = io(`https://crm.shreesolarsunstar.com`, {
  path: '/api/socket.io',
  transports: ['websocket'],
  autoConnect: false,
});
// const socket = io(`http://localhost:3333`, {
//   path: '/socket.io',
//   transports: ['websocket'],
//   autoConnect: false,
// });
export default socket;
